import axios, { AxiosInstance } from 'axios';
import { IRequestParams } from './type';
import {
  errorCode, addCommonHeaders, addPrefix,
} from './interceptors';

/*
  以下请求携带验签信息
 */
axios.defaults.withCredentials = true;

// 设置所有请求默认超时
axios.defaults.timeout = 25000; // 25秒

let APICONFIG = {
  autoApiPrefix: true,
  autoErrorCode: false,
};

//@ts-ignore
const axiosInstance: AxiosInstance = axios.create({ withCredentials: true });
axiosInstance.interceptors.request.use(addCommonHeaders);
axiosInstance.interceptors.request.use(addPrefix);
// axiosInstance.interceptors.response.use(loginCheck);

export default async (reqParams: IRequestParams) => {
  try {
    const { url } = reqParams || {};
    // 有的url没带'/'开头
    let _url = `${url.startsWith('/') || url.startsWith('http') ? url : `/${url}`}`;

    // 有的url没带api开头，自动添加/api，单个请求可通过其config覆盖是否自动添加
    if (APICONFIG.autoApiPrefix) {
      !_url.startsWith('/api') && !_url.startsWith('http') && (_url = `/api${_url}`);
    }

    const urlFinal = _url;

    if (APICONFIG.autoErrorCode) {
      axiosInstance.interceptors.response.use(errorCode);
    }

    const data: any = await axiosInstance({ ...reqParams, url: urlFinal });
    return data;
  } catch (error) {
    return {
      error
    };
  }
};
